// WorkshopRow — always-open host for ComposePanel. v0.5+ simplification
// (post-field-test): dropped the CTA + gear + sheet two-branch toggle
// entirely. Workshop chrome is now part of the chat surface permanently;
// operators don't toggle it open/closed. ComposePanel owns chip state +
// ChipManager + cross-tab sync.

import React from 'react';
import { ComposePanel } from '../../conversation/composePanel/ComposePanel';
import { useDiagMount } from '../../../utils/trailhead_diag';

interface WorkshopRowProps {
  personaId: string;
  persona: { name?: string };
  sessionId?: string;
}

export const WorkshopRow: React.FC<WorkshopRowProps> = ({ personaId, persona, sessionId }) => {
  useDiagMount('workshop', 'WorkshopRow', { personaId, sessionId });
  return (
    <div data-testid="workshop-row" className="shrink-0 min-w-0">
      <ComposePanel personaId={personaId} personaName={persona?.name} sessionId={sessionId} />
    </div>
  );
};
